export const VERIFY_LINK_KEY = 'verifyLink';

export const TARGET_PRICE_KEY = 'targetPrice';

export const PREVIOUS_INPUT_VALUE_KEY = 'previousInputValue';

export const PERCENTAGE_QUICK_SELECT_VALUES = [25, 50, 75, 100] as const;
